// extracted by mini-css-extract-plugin
module.exports = {"StrollerDetailRating":"xx_a bhu_a bhu_x","StrollerDetailRating__muted":"xx_b bhu_fi"};